
export const noBrandFilter = "Fără Brand"